import { render, staticRenderFns } from "./ListGiftCode.vue?vue&type=template&id=239aed26&scoped=true&"
import script from "./ListGiftCode.vue?vue&type=script&lang=js&"
export * from "./ListGiftCode.vue?vue&type=script&lang=js&"
import style0 from "./ListGiftCode.vue?vue&type=style&index=0&id=239aed26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239aed26",
  null
  
)

export default component.exports